import wasm from "refractor/wasm";
export default wasm;